import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent } from '@app/components/input-field/input-field.component';
import { AutoForm } from '@app/interfaces/auto-form.interface';
import { UserCreate } from '@app/models/user.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-user-form',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
    ],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss'
})
export class UserFormComponent {
  initialValue = input<UserCreate>();
  formChange = output<UserCreate>();
  formValid = output<boolean>();

  userForm = new FormGroup<AutoForm<UserCreate>>({
    display_name: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    banned_until: new FormControl<string>('', { nonNullable: true }),
    is_banned: new FormControl<boolean>(false, { nonNullable: true }),
  });

  constructor() {
    toObservable(this.initialValue).subscribe((initial) => {
      if(initial) {
        Object.keys(initial).forEach(key => {
          // https://stackoverflow.com/a/62438434/3341745
          let prop = key as keyof typeof initial;
          if(initial[prop] != null) {
            this.userForm.get(key)?.setValue(initial[prop]);
          }
        });
      }
      this.onChange();
    });
  }

  onChange() {
    this.formValid.emit(this.userForm.valid);
    this.formChange.emit(<UserCreate>this.userForm.value);
  }
}